var redefine = require('../internals/redefine');

module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/redefine-all.js
// module id = 54
// module chunks = 0